/* eslint-disable no-unused-vars */
const lengthwise = (bag, dimensions) => {
  return getNumBoxes(
    bag,
    dimensions.length,
    dimensions.width,
    dimensions.height,
    dimensions.measurement
  )
}

const lengthwiseRotated = (bag, dimensions) => {
  return getNumBoxes(
    bag,
    dimensions.width,
    dimensions.length,
    dimensions.height,
    dimensions.measurement
  )
}

const widthwise = (bag, dimensions) => {
  return getNumBoxes(
    bag,
    dimensions.length,
    dimensions.height,
    dimensions.width,
    dimensions.measurement
  )
}

const widthwiseRotated = (bag, dimensions) => {
  return getNumBoxes(
    bag,
    dimensions.height,
    dimensions.length,
    dimensions.width,
    dimensions.measurement
  )
}
const heightwise = (bag, dimensions) => {
  return getNumBoxes(
    bag,
    dimensions.height,
    dimensions.width,
    dimensions.length,
    dimensions.measurement
  )
}

const heightwiseRotated = (bag, dimensions) => {
  return getNumBoxes(
    bag,
    dimensions.width,
    dimensions.height,
    dimensions.length,
    dimensions.measurement
  )
}

const getNumBoxes = (bag, length, width, height, measurement) => {
  let bag_length = bag.length
  let bag_width = bag.width
  let bag_height = bag.height

  if (measurement === "metric") {
    bag_length = bag_length * 2.54
    bag_width = bag_width * 2.54
    bag_height = bag_height * 2.54
  }

  const lengthCount = Math.floor(bag_length / length)
  const widthCount = Math.floor(bag_width / width)
  const heightCount = Math.floor(bag_height / height)

  return lengthCount * widthCount * heightCount
}

const maxNumBoxesFitInBag = (bag, dimensions) => {
  return Math.max(
    lengthwise(bag, dimensions)
    // lengthwiseRotated(bag, dimensions),
    // widthwise(bag, dimensions),
    // widthwiseRotated(bag, dimensions),
    // heightwise(bag, dimensions),
    // heightwiseRotated(bag, dimensions)
  )
}

export { maxNumBoxesFitInBag }
